import PropTypes from 'prop-types'
import React, { Component } from 'react'
import Input from 'shared-web/src/components/Input'
import IntegrationConnector from '../components/IntegrationConnector'
import { APP_URL, SLACK_CLIENT_ID } from 'constants/ResourcesConstants'
import { captureException, captureResponseException } from 'utils/SentryHelpers'
import { patchSlackNotificationToggle, getSlackNotificationToggle } from 'app/modules/integrations/api'
import withNotifications from 'components/shared/notifications'
import IntegrationToggles from 'components/IntegrationToggles'
import {Toggle} from '@driftt/tide-core-legacy'
import ACCESS from 'utils/Access'
import { CustomerAPI } from '@driftt/dapper';

const PATCH_SUCCESS_MESSAGE = 'We saved your changes.'
const PATCH_ERROR_MESSAGE = 'We could not save your changes.'

const SlackPayload = {
  client_id: SLACK_CLIENT_ID,
  scope: "bot,incoming-webhook,channels:read,channels:write,users:read,commands,groups:write,groups:read",
  response_type: 'code',
  redirect_uri: `${APP_URL}/accept-integration/slack`
}
const SlackAuthUrl = 'https://slack.com/oauth/authorize'

class Slack extends Component {
  static contextTypes = {
    app: PropTypes.object.isRequired
  }

  state = {
    slackState: null,
    slackNotificationMode: null,
    slackChannelName: ''
  }

  fetchSlack = () => {
    this.context.app.actions.SlackTeamActions.fetchSlackTeam()
  }

  getStateParam = () => {
    const promise = this.context.app.sources.IntegrationsAPI.getStateParam()

    promise.then(res => {
      if (res.status === 200) {
        this.setState({ slackState: res.body.state })
      } else {
        captureResponseException(res)
      }
    })
  }

  renderSlackChannelInput = () => (
    <div>
      <Input
          label="SLACK CHANNEL"
          value={this.props.integrationStates.slackChannelName || this.state.slackChannelName}
          readOnly={true}
        />
        <p className = "slack-disconnect-info">
          Change your slack channel by disconnecting and reconnecting with a new channel selection.
        </p>
    </div>
  )


  renderSlackNotificationToggle = () => {
    const { slackNotificationMode } = this.state;
    return (
      <div className="slack-notification-setting">
        <div>
          <h2 className="integration-section-title">Limit Channel Creation</h2>
          <div className="slack-notification-setting-toggle">
            <p className="slack-notification-setting-description">
            Don't want us to create a new channel for every new Drift conversation? 
            No worries! Turn this setting on and we won't create any new channels. 
            Instead, you'll continue to receive a new conversation message in your 
            designated Slack channel with a link to that conversation on Drift.
            </p>
            <Toggle
              checked={slackNotificationMode}
              onChange={this.setSlackNotificationMode}
            />
          </div>
        </div>
      </div>
    )
  }
  
  setSlackNotificationMode = event => {
    this.setState({
      slackNotificationMode: event.target.checked
    })
  
    patchSlackNotificationToggle({ notificationsOnlyOn: event.target.checked })
      .then(this.onPatchSuccess)
      .catch(this.onPatchError);
  }
  onPatchError = e => {
    console.log(e);
    this.props.notifications.error(PATCH_ERROR_MESSAGE);
  }
  onPatchSuccess = () => {
    this.props.notifications.success(PATCH_SUCCESS_MESSAGE);
  }
  getSlackPayload = () => {
    return Object.assign({ state: this.state.slackState }, SlackPayload)
  }

  componentDidMount() {
    this.getStateParam()
    getSlackNotificationToggle().then(res => {
      this.setState({
        slackNotificationMode: res.status,
        slackChannelName: res.slackChannelName
      })
    })
  }

  render() {
    const { integrationStates, suppressUI } = this.props
    const isConnected = integrationStates && integrationStates.slackBot
    
    return (
      <div>
        <p>Get notifications in Slack for new Drift messages so you don&apos;t miss out on any conversations! With this integration, you can also chat with your site visitors right from Slack. </p>
        <p><a href="http://help.drift.com/article/slack-integration-respond-to-chats-right-from-slack" target="_blank">Learn more here!</a></p>
        {isConnected && <div>
          {this.renderSlackChannelInput()}
          {this.renderSlackNotificationToggle()}
        </div>}
        { !suppressUI && this.state.slackState && 
        <div className="connect-container">
          <IntegrationConnector
            integrationId="slackBot"
            isOauth={true}
            oauthLink={SlackAuthUrl}
            oauthQueryParams={this.getSlackPayload()}
            postSuccessCB={this.fetchSlack}
            title="Connect Account"
            connectorType="button"
            buttonType="primary"
            className="slack-integration-connector"
            />
          </div>}
      </div>
    )
  }
}

export default withNotifications(Slack)



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/services/Slack.js